/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Type containing required information fields
 */
export class RequiredInformationModel { 
    /**
     * Password is required
     */
    Password?: boolean;
    /**
     * Accepting Terms and Conditions is required
     */
    AcceptTermsAndConditions?: boolean;
    /**
     * Email address is required
     */
    EmailAddress?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/requiredInformationModel.ts